var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "<h5>("
    + container.escapeExpression(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"blobSelector.multiple",{"name":"i18n","hash":{},"data":data}))
    + ")</h5>";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.multiple : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n<div class=\"uploader\"></div>\n<div style=\"max-height: 360px; overflow-y: scroll;\">\n    <div class=\"blob-list-view\"></div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./common/ui/template/blob/selector.hbs
// module id = 688
// module chunks = 0